module.exports = __webpack_public_path__ + "img/headerLogo.0c4a3a5b.png";